import React, { useEffect, useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";
import { useHistory } from "react-router-dom";

import { deptSagaActions } from "../../Information/Department";
import { paymentReducerActions } from "../../Payment";

import { Form, Col, Card, Container, Spinner, Row, Button } from "react-bootstrap";
import { Search, ArrowBarLeft } from "react-bootstrap-icons";
import { DepartmentsCatalogueCarousel } from "../components/DepartmentsCatalogueCarousel";
import { ProvincialHeader } from "../components/ProvincialHeader";

import { useSubheader } from "../../../../_metronic/layout";
//import "../css/bootstrap-card-columns.css";

//import cardColStyles from "../css/CardColumn.module.css";

export const DepartmentsCatalogue = (props) => {

  const subheader = useSubheader();
  subheader.setTitle("Government Services");

  const dispatch = useDispatch();
  const history = useHistory();

  const { 
    dept : {entities: depts, totalCount: deptsTotalCount, listLoading},
    catalogue: { selectedProvince }
  } = useSelector((state) =>   state);
  
  useEffect(() => {
    dispatch(paymentReducerActions.resetState());
    if(selectedProvince.id){
      let query = { provinceId: selectedProvince.id };
      dispatch(deptSagaActions.fetchDeptsInProv(query));
    }
  }, [dispatch, selectedProvince]);
  
  
  const debounceFunction = (func, delay) => {
    
    let timer;
  
    return function() {
      let self = this;
      let args= arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(self, args)
      }, delay)
    }
  };
  
  //use useCallback to memoized or remeber the original function
  const debounceCatalogueSearch = useCallback(
    debounceFunction(
      (nextValue) => {
        let query = { str: nextValue };
        dispatch(deptSagaActions.searchDepts(query, selectedProvince.id));
      }, 500
    ), []
  );
  
  const handleBackNavigation = () => {
    history.push("/catalogue-management/provinces");
  };
  
  const handleCatalogueSearch = (event) =>{
    let nextValue = event.target.value;
    debounceCatalogueSearch(nextValue);
  };
  
  return (
    <Card>
      <Card.Header>
        <Row>
          <Col xl={9} sm={12}>
            <ProvincialHeader provName={selectedProvince.name} imgBase64={selectedProvince.flag_image} />
          </Col>
          <Col xl={3} sm={12}>
            <Button onClick={handleBackNavigation} style={{float:"right"}} variant="secondary" >
              <ArrowBarLeft size={18} /> {" "} BACK
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Container fluid>
          <Row>
            <Col>
              <Form.Group controlId="search">
              <Search size={30} className="pt-3 pl-3" style={{ position: "absolute" }}/>
                  <Form.Control
                    className="pl-10"
                    style={{ fontSize: "16px"}}
                    name="search"
                    placeholder="Search for a agency"
                    onChange={handleCatalogueSearch}
                  />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              { 
                listLoading 
                ? <Spinner className="listSpinner" animation="border" /> 
                : ( deptsTotalCount <= 0 ? <h5 className="d-flex justify-content-center">No Agencies Found</h5> 
                  : <DepartmentsCatalogueCarousel depts={depts} deptsTotalCount={deptsTotalCount} selectedProvince={selectedProvince} /> )
              }
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};
